import { render, staticRenderFns } from "./comboAssetsDetail.vue?vue&type=template&id=473f288a&scoped=true"
import script from "./comboAssetsDetail.vue?vue&type=script&lang=js"
export * from "./comboAssetsDetail.vue?vue&type=script&lang=js"
import style0 from "./comboAssetsDetail.vue?vue&type=style&index=0&id=473f288a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f288a",
  null
  
)

export default component.exports